import { render, staticRenderFns } from "./DiaryView.vue?vue&type=template&id=0063971d&scoped=true&lang=pug"
import script from "./DiaryView.vue?vue&type=script&lang=js"
export * from "./DiaryView.vue?vue&type=script&lang=js"
import style0 from "./DiaryView.vue?vue&type=style&index=0&id=0063971d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0063971d",
  null
  
)

export default component.exports